import React from "react";
import { Box, Button, Drawer, IconButton, Typography } from "@mui/material";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import AddRoundedIcon from "@mui/icons-material/AddRounded";

const MobileSessionDrawer = ({ open, onClose, onNewSession, isNewSessionDisabled, children }) => (
  <Drawer
    anchor="bottom"
    open={open}
    onClose={onClose}
    ModalProps={{ keepMounted: true }}
    PaperProps={{
      sx: {
        borderRadius: "20px 20px 0 0",
        maxHeight: "82vh",
        bgcolor: "#F9FCFA",
        display: "flex",
        flexDirection: "column",
        boxShadow: "0 -8px 28px rgba(18, 56, 42, 0.16)",
      },
    }}
  >
    <Box
      sx={{
        width: 38,
        height: 4,
        bgcolor: "#CBD5E1",
        borderRadius: 2,
        mx: "auto",
        mt: 1.25,
        mb: 0.5,
      }}
    />
    <Box
      sx={{
        px: 2.5,
        py: 1.25,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderBottom: "1px solid #DFECE5",
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 750, color: "#164A38", fontSize: "1.1rem" }}>
        Chat History
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <Button
          size="small"
          startIcon={<AddRoundedIcon />}
          onClick={onNewSession}
          disabled={isNewSessionDisabled}
          sx={{
            color: "#0C8F63",
            fontWeight: 700,
            bgcolor: "#EAF8F2",
            borderRadius: "8px",
            px: 1.5,
            py: 0.5,
            textTransform: "none",
            "&:hover": { bgcolor: "#D8F3E5" },
            "&.Mui-disabled": { opacity: 0.6 },
          }}
        >
          New Chat
        </Button>
        <IconButton
          aria-label="Close session history"
          onClick={onClose}
          size="small"
          sx={{ color: "#5C7268", bgcolor: "#EAEFEA", "&:hover": { bgcolor: "#DFE8DF" } }}
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      </Box>
    </Box>
    <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto" }}>{children}</Box>
  </Drawer>
);

export default MobileSessionDrawer;
